module.exports = __webpack_public_path__ + "static/media/visa_secure.c9c1030b.png";